import moduleName from '../moduleName';

export default {
  UPDATE_FILES: `${moduleName}/updateFiles`,
  CREATE_UPLOADER: `${moduleName}/createUploader`,
  DISPOSE_UPLOADER: `${moduleName}/disposeUploader`,
  INITIATE_UPLOADER: `${moduleName}/initiateUploader`,
};
